import ApiService from "@/utils/api.service";

export default {
    list(context, optionId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("field-option/" + optionId + "/images")
                .then(({ data }) => {
                    context.commit("setList", { optionId: optionId, list: data.data });
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    create(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("field-option/" + params.option_id + "/images", params).
                then(({ data }) => {
                    context.commit("setList", { optionId: params.option_id, list: data.data });
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        })
    },
    delete(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.delete("field-option/" + params.option_id + "/images/" + params.id)
                .then(({ data }) => {
                    context.commit("setList", { optionId: params.option_id, list: data.data });
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    clean(context) {
        context.commit("setList", []);
    }
}